import React from 'react';
import { cx, css } from 'linaria';
import { styled } from 'linaria/react';
import MaxWidth from '../../Layout/MaxWidth';
import { theme } from '../../Theme';

export const htmlStyles = css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: normal;
    font-weight: normal;
    margin-top: 0;
    margin-bottom: 0;
  }
  > * {
    font-weight: 300;
  }
  a {
    color: inherit;
  }
`;

const OuterWrapper = styled(MaxWidth)`
  --horizontal-mobile-padding: 20px;
  --vertical-mobile-padding: 35px;
  --horizontal-desktop-padding: 40px;
  --vertical-desktop-padding: 80px;

  padding: var(--horizontal-mobile-padding);

  &.vertial-padding {
    padding: var(--vertical-desktop-padding) var(--horizontal-desktop-padding);

    ${theme.below.md} {
      padding: var(--vertical-mobile-padding) var(--horizontal-mobile-padding);
    }
  }

  .startpagehtml-content {
    max-width: 650px;
    margin: 0 auto;
  }
`;

export const StartpageHtlm = ({ html, backgroundColor }) => {
  if (!html?.value) {
    return null;
  }

  return (
    <div
      className="startpagehtml-component-wrapper"
      style={{
        backgroundColor: backgroundColor?.value || undefined,
      }}
    >
      <OuterWrapper
        className={cx(
          'startpagehtml-component',
          backgroundColor?.value &&
            backgroundColor?.value?.toLowerCase() !== '#ffffff' &&
            'vertial-padding'
        )}
      >
        <div
          className={cx('startpagehtml-content', htmlStyles)}
          dangerouslySetInnerHTML={{ __html: html?.value }}
        />
      </OuterWrapper>
    </div>
  );
};
